import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../Components/Form";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { InserirCasoDinamicamenteController } from "../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarCategoriaRepasseController } from "../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { ListarBancosController } from "../../../../Controllers/Geral/ListarBancosController/ListarBancosController";
import { ListarAnalistasDeCreditoController } from "../../../../Controllers/Vendas/AnaliseDeCredito/AnaliseDeCreditoControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IGestaoRepasseLista } from "../../../../Interfaces/Repasse/GestaoRepasse/GestaoRepasseInterfaces";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";

interface IAbrirCasoModalProps {
    gestaoRepasse: IGestaoRepasseLista;
    setShow: Dispatch<SetStateAction<boolean>>;
    updateList: () => void;
}

interface IFormData {
    VL_SUBSIDIO: number;
    VL_FINANCIAMENTO: number;
    ID_CATEGORIA_ATENDIMENTO: number;
    ID_BANCO: number;
    VL_FGTS: number;
    ID_USUARIO_RESPONSAVEL: number;
}

export default function AbrirCasoModal(props: IAbrirCasoModalProps) {
    const { execute: abrirCasoRepasse, loading: abrirCasoRepasseLoading } =
        useAsyncCallback(InserirCasoDinamicamenteController);

    const { id } = useModuloInfo();

    const gestaoRepasse = props.gestaoRepasse;

    function handleAbrirCaso(formData: IFormData) {
        abrirCasoRepasse({
            ...formData,
            ...gestaoRepasse,
            ID_TIPO_CASO: id,
            ID_USUARIO_RESPONSAVEL: formData.ID_USUARIO_RESPONSAVEL,
            VL_FGTS: formData.VL_FGTS,
            VL_FINANCIAMENTO: formData.VL_FINANCIAMENTO,
            VL_SUBSIDIO: formData.VL_SUBSIDIO,
        }).then(() => {
            props.setShow(false);
            props.updateList();
        });
    }

    return (
        <>
            <UnForm
                handleSubmit={handleAbrirCaso}
                className="d-flex justify-content-between flex-column"
            >
                <div className="d-flex justify-content-between flex-column align-items-center">
                    <UnForm.LazySelect
                        name="ID_CATEGORIA_ATENDIMENTO"
                        wrapperClassName="col-8"
                        label="Categoria Atendimento"
                        controller={ListarCategoriaRepasseController}
                        getDS={(ct) => ct.DS_CATEGORIA_ATENDIMENTO}
                        getKeyValue={(ct) => ct.ID_CATEGORIA_ATENDIMENTO}
                    >
                        <option></option>
                    </UnForm.LazySelect>

                    <UnForm.LazySelect
                        label="Analistas de Crédito"
                        name="ID_USUARIO_RESPONSAVEL"
                        registerOptions={{
                            valueAsNumber: true,
                        }}
                        wrapperClassName="col-8"
                        controller={ListarAnalistasDeCreditoController}
                        getDS={(u) => u.DS_NOME}
                        getKeyValue={(u) => u.ID_USUARIO}
                    >
                        <option value={0}></option>
                    </UnForm.LazySelect>

                    <UnForm.LazySelect
                        controller={ListarBancosController}
                        label="Banco"
                        name="ID_BANCO"
                        className={`form-control placeholder-dark-50`}
                        wrapperClassName="col-8"
                        getDS={(b) => b.DS_BANCO}
                        getKeyValue={(b) => b.ID_BANCO}
                    >
                        <option></option>
                    </UnForm.LazySelect>

                    <UnForm.Input
                        label="Valor Financiamento"
                        name="VL_FINANCIAMENTO"
                        wrapperClassName="col-8"
                        defaultValue={formatMoneyReais(
                            gestaoRepasse.VL_FINANCIAMENTO
                        )}
                        registerOptions={{
                            required: "Insira o Valor do Financiamento:",
                            setValueAs: (v: string) =>
                                Number(MoneyReaisFieldMask.unMask(v)),
                        }}
                        onChange={MoneyReaisFieldMask}
                    />

                    <UnForm.Input
                        label="Valor FGTS"
                        name="VL_FGTS"
                        wrapperClassName="col-8"
                        defaultValue={formatMoneyReais(gestaoRepasse.VL_FGTS)}
                        registerOptions={{
                            required: "Insira o Valor do FGTS:",
                            setValueAs: (v: string) =>
                                Number(MoneyReaisFieldMask.unMask(v)),
                        }}
                        onChange={MoneyReaisFieldMask}
                    />

                    <UnForm.Input
                        label="Valor Subsídio"
                        name="VL_SUBSIDIO"
                        wrapperClassName="col-8"
                        defaultValue={formatMoneyReais(
                            gestaoRepasse.VL_SUBSIDIO
                        )}
                        registerOptions={{
                            required: "Insira o Valor do Subsídio:",
                            setValueAs: (v: string) =>
                                Number(MoneyReaisFieldMask.unMask(v)),
                        }}
                        onChange={MoneyReaisFieldMask}
                    />
                </div>

                <footer className="col-12 d-flex justify-content-end g-2 align-items-center mt-5">
                    <button
                        type="button"
                        className="btn btn-outline-success"
                        onClick={() => {
                            props.setShow(false);
                        }}
                    >
                        Fechar
                    </button>
                    <UnForm.SubmitButton
                        color="primary"
                        icon={faBoxOpen}
                        className="btn btn-outline-primary"
                        noDiv={true}
                        loading={abrirCasoRepasseLoading}
                        loadingSize="sm"
                    >
                        Abrir Atendimento
                    </UnForm.SubmitButton>
                </footer>
            </UnForm>
        </>
    );
}
